import orderBy from "lodash/orderBy";
import type { FC } from "react";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";
import NoteSimpleInput from "../noteStampedList/NoteSimpleInput";
import type { Note } from "./Notes";
import Notes from "./Notes";
import { useAuthContext } from "../../auth/AuthContext";

interface Props {
  readonly notes: Note[];
  readonly onChange: (notes: Note[]) => void | Promise<void>;
}

const SimpleNotes: FC<Props> = ({ notes, onChange }) => {
  const { user } = useAuthContext();
  const orderedNotes = orderBy(notes, (n) => n.date, ["desc"]);

  const handleAddNote = async ({ text }: Pick<Note, "text">) => {
    if (user?.email) {
      await onChange([{ text, date: dayjs().format(ISO_DATE_FORMAT), author: user.email }, ...orderedNotes]);
    }
  };

  const handleDeleteNote = async (idx: number) => {
    await onChange(orderedNotes.filter((n, i) => i !== idx));
  };

  return (
    <Notes notes={orderedNotes} onDeleteNote={handleDeleteNote}>
      <NoteSimpleInput label="Nowa notatka" onSubmit={(text) => handleAddNote({ text })} />
    </Notes>
  );
};

export default SimpleNotes;
